import api from './api';
import { ApiResponse } from '../types';

export interface FeeWaiver {
  _id: string;
  invoiceId: string;
  studentId: string;
  lineItemIndex: number | null;
  amount: number;
  reason: string;
  createdAt: string;
  createdBy?: string | { _id: string; firstName?: string; lastName?: string } | null;
  isActive: boolean;
  revokedAt?: string | null;
  revocationReason?: string;
}

export const listWaivers = async (invoiceId: string): Promise<FeeWaiver[]> => {
  const r = await api.get<ApiResponse<{ waivers: FeeWaiver[] }>>(`/fee-waivers/invoice/${invoiceId}`);
  if (!r.data.success) throw new Error(r.data.message);
  return r.data.data!.waivers;
};

export interface CreateWaiverInput {
  lineItemIndex: number | null;
  amount: number;
  reason: string;
}

/** `pending` when the waiver is above the school's limit and waits for a second person. */
export const createWaiver = async (invoiceId: string, input: CreateWaiverInput): Promise<{ pending: boolean }> => {
  const r = await api.post<ApiResponse<{ pending: boolean }>>(`/fee-waivers/invoice/${invoiceId}`, input);
  if (!r.data.success) throw new Error(r.data.message);
  return r.data.data!;
};

export const revokeWaiver = async (waiverId: string, reason?: string): Promise<FeeWaiver> => {
  const r = await api.post<ApiResponse<FeeWaiver>>(`/fee-waivers/${waiverId}/revoke`, { reason });
  if (!r.data.success) throw new Error(r.data.message);
  return r.data.data!;
};

const feeWaiverService = { listWaivers, createWaiver, revokeWaiver };
export default feeWaiverService;
